import { AxiosInstance } from 'axios';

import { transformToCamelCase } from '$app-web/utils';

export function transformResponseToCamelCase(axios: AxiosInstance): void {
    axios.interceptors.response.use((response) => {
        const { data } = response;
        const transformedData = transformToCamelCase(data);

        return { ...response, data: transformedData };
    });
}
